// React is used implicitly by JSX
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CampaignBalance from './pages/CampaignBalance';
import ImageViewer from './pages/ImageViewer';
import PDFViewer from './pages/PDFViewer';
import Banners from './pages/Banners';
import VerifyEmail from './pages/VerifyEmail';
import MfaSetup from './pages/MfaSetup';
import MfaChallenge from './pages/MfaChallenge';
import Security from './pages/Security';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/mfa-setup" element={<MfaSetup />} />
            <Route path="/mfa-challenge" element={<MfaChallenge />} />
            {/* Public routes that don't require authentication */}
            <Route path="/image-viewer" element={<ImageViewer />} />
            <Route path="/pdf-viewer" element={<PDFViewer />} />
            {/* Protected routes within Layout */}
            <Route
              path="/"
              element={(
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              )}
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="campaign-balance" element={<CampaignBalance />} />
              <Route path="banners" element={<Banners />} />
              <Route path="security" element={<Security />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
